module.exports = __webpack_public_path__ + "img/crizal.327ec195.jpg";